import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const STORAGE_KEY = 'language';
const DEFAULT_LANG = 'tr';

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === 'undefined') {return DEFAULT_LANG;}
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === 'tr' || saved === 'en' ? saved : DEFAULT_LANG;
  });

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'tr' || saved === 'en') {setLanguage(saved);}
  }, []);

  const changeLanguage = lang => {
    if (lang !== 'tr' && lang !== 'en') {return;}
    setLanguage(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
